import {
  Anchor,
  Column,
  CountryH4,
  DropdownAnchor,
  GenericDropdown,
} from 'components/Header/Styled'

export const NavDropdown = (props) => {
  const NavigationItems =
    props.navigation_items &&
    props.navigation_items.length > 0 &&
    props.navigation_items.map(({ title, link }, index) => (
      <DropdownAnchor key={index} href={link}>
        {title}
      </DropdownAnchor>
    ))
  return (
    <GenericDropdown title={props.title}>
      <Column>{NavigationItems}</Column>
    </GenericDropdown>
  )
}

export const CityDropdown = ({ cities }) => {
  const Cities =
    cities &&
    cities.length > 0 &&
    cities.map((country, index) => (
      <Column key={index}>
        <CountryH4>{country.title}</CountryH4>
        {country.navigation_items &&
          country.navigation_items.length > 0 &&
          country.navigation_items.map((city, index) => (
            <Anchor key={index} title={city.title} href={city.link}>
              {city.title}
            </Anchor>
          ))}
      </Column>
    ))
  return <GenericDropdown title='Top Cities'>{Cities}</GenericDropdown>
}
